// extracted by mini-css-extract-plugin
export var link = "footer-nav-module--link--20a7c";
export var nav = "footer-nav-module--nav--5685f";
export var title = "footer-nav-module--title--072ad";